import React, { Component } from 'react';
import graphql from 'babel-plugin-relay/macro';
import { QueryRenderer } from 'react-relay';
import { Redirect } from 'react-router-dom';
import AbEnvironment from '../auth/AbEnvironment';
import withStyles from '@mui/styles/withStyles';
import { Grid, Paper, Typography } from '@mui/material';
import Communications from '../notification/Communications';
import PageTitle from '../ui/PageTitle';
import LoadingSpinner from '../ui/LoadingSpinner';
import ServerError from '../ui/ServerError';

import { Email } from '@mui/icons-material';

const abEnvironment = new AbEnvironment();
const CommunicationTemplateListQuery = graphql`
query CommunicationTemplateListQuery($accountId: UUID!) {
  allCommunicationTemplateTs(condition: {accountId: $accountId}) {

    nodes {
      ctId
      templateName
    }
 }
}
`;
const styleSheet = theme => ({
    root: {
        flexGrow: 1,
    },
    paper: {
      padding: theme.spacing(2)
    },
    commType: {
      float: 'left',
      marginRight: 15,
      marginTop: 3
    },
    commDescription: {
      float: 'left',
      maxWidth: 200,
  
    },
    templateStatus: {
      float: 'right',
      marginTop: 3,
      clear: 'right',
    },
    dbTile: {
        [theme.breakpoints.up('xs')]: {
          padding: theme.spacing(1),
        },
        [theme.breakpoints.up('sm')]: {
          padding: theme.spacing(1),
        },
        [theme.breakpoints.up('md')]: {
          padding: theme.spacing(2),
        },
        height: 100,
        width: 260
      },
    dbTileSelected: {
      [theme.breakpoints.up('xs')]: {
        padding: theme.spacing(1),
      },
      [theme.breakpoints.up('sm')]: {
        padding: theme.spacing(1),
      },
      [theme.breakpoints.up('md')]: {
        padding: theme.spacing(2),
      },
      height: 100,
      width: 260,
      backgroundColor: '#D3D3D3'
    }
});

class CommunicationTemplateList extends Component {

    state = {
      communicationType: null
    };

    componentDidMount() {
      let type = localStorage.getItem('communicationType');
      if (type !== null) {
        let iType = parseInt(type, 10);
         this.setState({communicationType: iType});
      }
  
    }

    handleTileClick(type) {
      localStorage.setItem('communicationType', type);
      let route = 'communicationtemplate?name=';
      if (type === 0) {
        route = route + 'CustStatements';
      } else if (type === 1) {
        route = route + 'CustInvite';
      } else if (type === 2) {
        route = route + 'PayoutNotif';
      }

      this.props.history.push(`/${route}`);
    }

    render() {

      const { isAuthenticated, isAuthenticatedReseller, isAuthenticatedVendor, needAssent, logError } = this.props.auth;
      const classes = this.props.classes;

      if ((!isAuthenticated() && !isAuthenticatedVendor()) || needAssent()) {
        return (
          <Redirect to='/home' />
        );
      }
  
      //more personas added as time goes on here - for now....
      if (isAuthenticatedReseller() || isAuthenticatedVendor())
      {
        let accountId = abEnvironment.getUserAttribute('a_id');
  
        return (
            <QueryRenderer
              environment={abEnvironment.getEnvironment()}
              query={CommunicationTemplateListQuery}
              variables={{accountId: accountId}}
              render={({error, props})=> {
                if (error) {
                  logError(error.message);
                  return (
                    <ServerError/>
                  );
                } else if (props) {
                  let templates = new Set();
  
                  // Options from result of query
                  if (props.allCommunicationTemplateTs.nodes.length !== 0) {

                    for (var i = 0; i < props.allCommunicationTemplateTs.nodes.length; i++) {
                      templates.add(props.allCommunicationTemplateTs.nodes[i].templateName);
                    }

                  } 

                  return ( 
                    
                    <div className={classes.root}>
                      <PageTitle title="Communications" subtitle={'Customize email and text notifications.'}/>

                      <Grid container spacing={2} direction="row" >
                        <Grid item xs={12}>
                          <Paper className={classes.paper}>
                            <Grid container spacing={2} justifyContent="flex-start">
                              <Grid item xs={12}>
                                <Typography variant="h6">
                                  Communication templates
                                </Typography>
                              </Grid>
                              {isAuthenticatedReseller() &&
                                <React.Fragment>
                                  <Grid item>
                                    <Paper className={(this.state.communicationType === 1 ? classes.dbTileSelected : classes.dbTile)}  onClick={() => { this.handleTileClick(1)  }}>
                                      <Grid container spacing={2}>                               
                                        <Grid item xs={12}>
                                          <div className={classes.commType}>
                                            <Email />
                                          </div>
                                          <div className={classes.commDescription} >
                                            <Typography variant="h6" noWrap>
                                              Customer invitation
                                            </Typography>
                                          </div>
                                          {/*
                                          <div className={classes.templateStatus}>
                                          { templates.has("CustInvite")  === true &&
                                            <CheckCircle htmlColor={statusSetup}/>
                                          }
                                          </div>
                                          */}
                                        </Grid>
                                        <Grid item xs={12}>
                                          <Typography variant="body2">
                                            The default email you send to new customers.  You can personalize it when you send it.
                                          </Typography>
                                        </Grid>
                                      </Grid>
                                    </Paper>
                                  </Grid>
                                  <Grid item>
                                    <Paper className={(this.state.communicationType === 0 ? classes.dbTileSelected : classes.dbTile)}  onClick={() => { this.handleTileClick(0)  }}>
                                      <Grid container spacing={2}>
                                        <Grid item xs={12}>
                                          <div className={classes.commType}>
                                            <Email />
                                          </div>
                                          <div className={classes.commDescription} >
                                            <Typography variant="h6" noWrap>
                                              Monthly statements
                                            </Typography>
                                          </div>
                                          {/*
                                          <div className={classes.templateStatus}>
                                            { templates.has("CustStatements")  === true &&
                                              <CheckCircle htmlColor={statusSetup}/>
                                            }
                                          </div>
                                          */}
                                        </Grid>
                                        <Grid item xs={12}>
                                          <Typography variant="body2">
                                            You can turn on monthly statements for any customer who wants to receive them.  This is the email we send on their billing day.
                                          </Typography>
                                        </Grid>
                                      </Grid>
                                    </Paper>
                                  </Grid>
                                </React.Fragment>
                              }
                              {isAuthenticatedVendor() &&
                                <React.Fragment>
                                  <Grid item>
                                    <Paper className={(this.state.communicationType === 2 ? classes.dbTileSelected : classes.dbTile)}  onClick={() => { this.handleTileClick(2)  }}>
                                      <Grid container spacing={2}>                               
                                        <Grid item xs={12}>
                                          <div className={classes.commType}>
                                            <Email />
                                          </div>
                                          <div className={classes.commDescription} >
                                            <Typography variant="h6" noWrap>
                                              Commission notification
                                            </Typography>
                                          </div>
                                        </Grid>
                                        <Grid item xs={12}>
                                          <Typography variant="body2">
                                            The default email you send to resellers for a payout.
                                          </Typography>
                                        </Grid>
                                      </Grid>
                                    </Paper>
                                  </Grid>
                                </React.Fragment>
                              }
                            </Grid>
                                    
                          </Paper>                        
                        </Grid>
                        <Grid item xs={12}>
                          <Paper className={classes.paper}>
                            <Communications auth={this.props.auth} history={this.props.history}/>
                          </Paper>
                        </Grid>
                      </Grid>
                    </div>
                  );
                }
                return (
                  <div>
                    <Typography>Loading...</Typography>
                    <LoadingSpinner/>
                  </div>
                );
              }}
            />
        );
      }
      else
      {
        return (
          <Redirect to='/home' />
        );
      }

     }
}

export default withStyles(styleSheet)(CommunicationTemplateList);